import PropertyDetails from './property-details';

export default PropertyDetails;